import {
  GET_JOB_LISTING,
  CHANGE_CURRENT_JOB_PAGE,
  SET_JOB_ITEMS_PER_PAGE,
  SEARCH_JOBS,
  JOB_STATUS,
  JOB_STATUS_FILTER,
  CANDIDATE_JOB_STATUS,
  RESET_CANDIDATE_JOB_STATUS,
  ASSET_URL,
  NOTIFY_NEXT_CANDIDATES,
  NOTIFY_NEXT_CANDIDATES_SUCCESS,
  JOB_DETAILS,
  INTERVIEW_LIST,
  DRAFT_EMAIL_DETAILS
} from "../actions/jobAction";

const initialState = {
  jobListing: [],
  jobListTotalResults: null,
  jobListTotalPages: null,
  jobListPageIds: [],
  fetchingData: true,
  jobListSearchText: "",
  jobListCurrentPage: 1,
  jobListResultPerPage: 10,
  jobStatusList: [],
  jobStatusFliter: [],
  candidateJobStatus: [],
  asset_url: "",
  jobDetails:[],
  interviewListData:[],
  draftEmailData:[]
};

const jobListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_JOB_LISTING: {
      return {
        ...state,
        jobListing: action.payload.results,
        jobListTotalResults: action.payload.total_results,
        jobListTotalPages: action.payload.total_pages,
        jobListPageIds: action.payload.page_ids,
        fetchingData: false,
      };
    }

    case CHANGE_CURRENT_JOB_PAGE: {
      return {
        ...state,
        jobListCurrentPage: action.payload,
      };
    }

    case SET_JOB_ITEMS_PER_PAGE: {
      return {
        ...state,
        jobListResultPerPage: action.payload,
      };
    }
    case SEARCH_JOBS: {
      return {
        ...state,
        jobListSearchText: action.payload,
      };
    }

    case JOB_STATUS: {
      return {
        ...state,
        jobStatusList: action.payload,
      };
    }

    case JOB_STATUS_FILTER: {
      return {
        ...state,
        jobStatusFliter: action?.payload || [],
      };
    }

    case CANDIDATE_JOB_STATUS: {
      return {
        ...state,
        candidateJobStatus: action.payload || [],
      };
    }

    case RESET_CANDIDATE_JOB_STATUS: {
      return {
        ...state,
        candidateJobStatus: [],
      };
    }

    case ASSET_URL: {
      return {
        ...state,
        asset_url: action?.payload,
      };
    }

    case NOTIFY_NEXT_CANDIDATES: {
      return {
        ...state,
        fetchingData: true,
      };
    }
    case NOTIFY_NEXT_CANDIDATES_SUCCESS: {
      return {
        ...state,
        fetchingData: false,
      };
    }

     case JOB_DETAILS:{
      return{
        ...state,
        jobDetails:action.payload,
      };
    }

     case INTERVIEW_LIST:{
      return{
        ...state,
        interviewListData:action.payload,
      }
    }
         case DRAFT_EMAIL_DETAILS:{
      return{
        ...state,
        draftEmailData:action.payload,
      }
    }
    default:
      return state;
  }
};
export default jobListingReducer;